import React from 'react';
import Clock from '../../../assets/svg/clock';
import './ScheduleModal.css';

const BreakMinutesInput = ({ breakMinutes, setBreakMinutes }) => {
  return (
    <div className='flex-columns flex-1' style={{ marginTop: 16 }}>
      <div>
        <span className='create-schedule-label'>Minutes of Break</span>
      </div>
      <div className='flex-rows create-schedule-date-input' style={{ marginTop: 8 }}>
        <div className='flex-columns' style={{ justifyContent: 'center', marginLeft: 8 }}>
          <Clock fill='#B4B4C6' />
        </div>
        <div className='flex-columns' style={{ marginLeft: 16, justifyContent: 'center' }}>
          <input id='breakMinutesInput' type='number' min={0} value={breakMinutes} className='create-schedule-input-text' onChange={event => setBreakMinutes(event.target.value)} />
        </div>
      </div>
    </div>
  );
};

export default BreakMinutesInput;
